import { render, staticRenderFns } from "./index_old.vue?vue&type=template&id=49da9458&scoped=true&"
import script from "./index_old.vue?vue&type=script&lang=js&"
export * from "./index_old.vue?vue&type=script&lang=js&"
import style0 from "./index_old.vue?vue&type=style&index=0&id=49da9458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da9458",
  null
  
)

component.options.__file = "index_old.vue"
export default component.exports